import { Container, Navbar } from "react-bootstrap";

//const logo = require("./img/logoLgr.png")

//menu ausili,pratiche,assistiti

function Header() {
	return (
		<div>
			<Navbar
				collapseOnSelect
				expand="lg"
				fixed="top"
				variant="dark"
				style={{
					backgroundColor: "#039ee3",
				}}
			>
				<Container fluid>
					<Navbar.Brand>
						<img
							src={"/img/logoLgr.png"}
							style={{
								width: 60,
								height: 30,
							}}
							className="d-inline-block align-top"
							alt="LGR"
						/>
					</Navbar.Brand>
					<Navbar.Toggle aria-controls="basic-navbar-nav" />
				</Container>
			</Navbar>
			<div style={{ height: 55 }}></div>
		</div>
	);
}

export default Header;
